import React, {useEffect, useState} from 'react';
import {Row, Col, Image, Collapse, message, Modal} from "antd";
import ReactMarkdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';
import './index.css'
import {getWalletInfo} from "../../../api/user";
import {getLlmModelList,getProductsList,getCommonQaList} from "../../../api/other";
import OpenCard from "./buyCard";
import ReturnCard from "./returnCard";
import remarkGfm from 'https://esm.sh/remark-gfm@4'

const App = () => {

    const [isOpenCard, setIsOpenCard] = useState(false);
    const [walletInfo,setWalletInfo] = useState(null)
    const [currencies,setCurrencies] = useState([])
    const [cards,setCards] = useState([])
    const [cardList,setCardList] = useState([])
    const [qaList,setQaList] = useState([])
    const [llmModel,setLlmModelList] = useState([])
    const [buyCardInfo,setBuyCardInfo] = useState(null)
    const [isReturnCard,setIsReturnCard] = useState(false)
    var isLoad = false
    useEffect(()=>{
        if (!isLoad) {
            isLoad = true
            getAllCards()
            getWalletInfoList()
            getQaList()
            getLlmList()
        }
    },[])
    const getWalletInfoList = ()=>{
        getWalletInfo().then(res=>{
            if(res.code === 200){
                setWalletInfo(res.data)
                setCurrencies(res?.data?.currencies || [])
                setCards(res?.data?.cards || [])
            }
        })
    }
    const getLlmList = ()=>{
        getLlmModelList().then(res=>{
            if(res.code === 200){
                setLlmModelList(res?.data)
            }
        })
    }
    const getQaList = ()=>{
        getCommonQaList().then(res=>{
            if(res.code === 200){
                setQaList(res?.data)
            }
        })
    }
    const getAllCards = ()=>{
        getProductsList().then(res=>{
            if(res.code === 200){
                setCardList(res?.data?.vCNY_Settlement_Products_List)
            }
        })
    }
    //买卡
    const handleBuyCard = (v)=>{
        if(v.unit_price>currencies[0]?.balance){
            message.warning('账户余额不足，请先充值！')
            return false
        }
        setBuyCardInfo(v)
        setIsOpenCard(true)
    }
    //开卡弹窗 确定后执行操作
    const handleOk = ()=>{
        setIsOpenCard(false)
        getAllCards()
        getWalletInfoList()
    }
    //退卡
    const handleReturnCard = ()=>{
        setIsReturnCard(true)
    }
    const handleReturnOk = ()=>{
        setIsReturnCard(false)
        getWalletInfoList()
    }
    return(
        <div className='bmBg' style={{fontSize:'80px'}}>
            <div className={'bmBgWrap'}>
                <Row gutter={40}>
                    <Col span={24}>
                        <div className={'bmLeftCard2'}>
                            {
                                cards.length>0?
                                    <div className={'bm_mCard'}>
                                        <Row gutter={20}>
                                            <Col span={13}>
                                                <Image src={cards[0].card_image} width={175} preview={false} style={{marginTop:'5px'}}></Image>
                                                <div className={'bm_tk22'}>
                                                    <span onClick={handleReturnCard}>退卡</span>
                                                </div>
                                            </Col>
                                            <Col span={10} style={{textAlign:'left'}} offset={1}>
                                                <div className={'bm_cardM'}>卡片面值： {cards[0].currency_code==='vCNY'?'￥':'$'}{cards[0]?.prepaid_amount}</div>
                                                <div className={'bm_cardP'}>卡内余额： {cards[0].currency_code==='vCNY'?'￥':'$'}{cards[0]?.balance}</div>
                                                <div className={'bm_cardT'}>到期时间： {cards[0].expire_at.substring(0,10)}</div>
                                            </Col>
                                        </Row>
                                        <div className={'bm_jh'}>当前激活</div>
                                    </div>
                                    :
                                    <div className={'bm_mNoCard'}>
                                        <Row gutter={20}>
                                            <Col span={14}>
                                                <Image src={require('../../../assets/comm/llm-no.png')} width={180} preview={false} style={{marginTop:'5px'}}></Image>
                                                <div className={'bm_tk23'}>
                                                    <span>退卡</span>
                                                </div>
                                            </Col>
                                            <Col span={10} style={{textAlign:'left'}}>
                                                <div className={'bm_cardM'}>卡片面值: $-</div>
                                                <div className={'bm_cardP'}>卡内余额: $-</div>
                                                <div className={'bm_cardT'}>到期时间: -</div>
                                            </Col>
                                        </Row>

                                        <div className={'bm_jh'} >暂未开通</div>
                                    </div>
                            }
                        </div>
                    </Col>
                    <Col span={24}>
                        <div className={'bmRightCard2'}>
                        {
                            cardList&&cardList.length>0?
                                cardList.map((res,i)=>{
                                    return (<div className={'bm_cardImage_p'} key={'card-buy-'+i}>
                                        <Row>
                                            <Col span={11}>
                                                <div className={'bm_cardImage_t'}>
                                                    <Image src={res?.product_image} width={160} preview={false} style={{margin:'5px auto 0'}}></Image>
                                                </div>
                                            </Col>
                                            <Col span={10}>
                                                <div className={'bm_detail'}>
                                                    <div><span>售价：</span>{res.unit_price}</div>
                                                    <div><span>库存：</span>{res.available_quantity}</div>
                                                    <div><span>说明：</span>{res.product_intro}</div>
                                                </div>
                                            </Col>
                                            <Col span={3}>
                                                <div className={'bm_tk22'}>
                                                    <span onClick={()=>handleBuyCard(res)}>开卡</span>
                                                </div>
                                            </Col>
                                        </Row>

                                    </div>)
                                }):''
                        }
                        </div>
                    </Col>
                    <Col span={24} style={{paddingBottom:'50px'}}>
                        <div className={'bm_tips'}>*只需开通任意面额的预付卡，即可访问所有大语言模型（GPT系列、O1系列、Claude系列、Gemini系列、LIama系列.</div>
                        <div className={'bm_tips2'}>*LLM预付卡的余额不可叠加，开通新卡将导致旧卡立即失效</div>
                        <div className={'bm_line'}></div>
                        <div className={'bm_title'}>模型列表</div>
                        <div className={'markHtml'}>
                            <ReactMarkdown skipHtml={true} remarkPlugins={[remarkGfm]}>
                                {llmModel.toString()}
                            </ReactMarkdown>
                        </div>
                        <div className={'bm_line'}></div>
                        <div className={'bm_title'}>常见问题</div>
                        <div className={'markHtml'}>
                            <ReactMarkdown skipHtml={true} remarkPlugins={[remarkGfm]}>
                                {qaList.toString()}
                            </ReactMarkdown>
                        </div>
                    </Col>
                </Row>
            </div>
            <Modal footer={null} destroyOnClose={true} open={isOpenCard} onCancel={handleOk} width={360}>
                <OpenCard buyCardInfo={buyCardInfo} handleOk={handleOk} />
            </Modal>
            <Modal footer={null} destroyOnClose={true} open={isReturnCard} onCancel={handleReturnOk} width={360}>
                <ReturnCard returnCardInfo={cards[0]} handleReturnOk={handleReturnOk} />
            </Modal>
        </div>
    )
};
export default App;
